import { Component, OnInit } from '@angular/core';
import { TabPanelComponent } from '../../core/panels/tab-panel/tab-panel.component';
import { TabComponent } from '../../core/panels/tab-panel/tab.component';
import { BaseComponent } from '../../base/base.component';
import {
  DIARY_SHARED_SUBTAB_CLAIM,
  DIARY_SHARED_SUBTAB_MAIN,
  DiarySharedSubTab,
} from './diary-storage.keys';
import { DiaryMyDiariesComponent } from './diary-my-diaries.component';
import { DiarySearchPanelComponent } from './diary-search-panel.component';

@Component({
  selector: 'app-diary-view',
  imports: [
    TabPanelComponent,
    TabComponent,
    DiaryMyDiariesComponent,
    DiarySearchPanelComponent,
  ],
  template: `
    <p
      class="tw-italic tw-text-[var(--sed-black-80-color)] tw-text-sm tw-pb-4 tw-pt-2"
    >
      Shared diaries are visible to all users with Shared diary access for the
      selected client and/or claim. Use the My diaries tab to view diaries
      assigned to you, or the Search diaries tab to find other diaries.
    </p>

    <app-tab-panel
      [value]="subTabValue"
      [lazy]="false"
      (valueChange)="onSubTabChange($event)"
    >
      <app-tab label="My diaries" value="my-diaries">
        <ng-template #content>
          <div class="tw-pt-4">
            <app-diary-my-diaries />
          </div>
        </ng-template>
      </app-tab>
      <app-tab label="Search diaries" value="search">
        <ng-template #content>
          <div class="tw-pt-4">
            <app-diary-search-panel />
          </div>
        </ng-template>
      </app-tab>
    </app-tab-panel>
  `,
  styles: ``,
})
export class DiaryViewComponent extends BaseComponent implements OnInit {
  subTabValue: DiarySharedSubTab = 'my-diaries';
  isPageTodo = false;

  ngOnInit(): void {
    this.isPageTodo = document.location.pathname === '/todo';
    const key = this.isPageTodo
      ? DIARY_SHARED_SUBTAB_MAIN
      : DIARY_SHARED_SUBTAB_CLAIM;
    const saved = this.storage.get(key) as DiarySharedSubTab | undefined;
    if (saved === 'my-diaries' || saved === 'search') {
      this.subTabValue = saved;
    }
  }

  onSubTabChange(value: string): void {
    this.subTabValue = value as DiarySharedSubTab;
    const key = this.isPageTodo
      ? DIARY_SHARED_SUBTAB_MAIN
      : DIARY_SHARED_SUBTAB_CLAIM;
    this.storage.set(key, this.subTabValue);
  }
}
